// src/componentes/confirmacao/ConfirmacaoServico.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import EasyModal from '../easymodal/easymodal';

type ConfirmacaoOptions = {
  titulo?: string;
  mensagem?: string;
  textoConfirmar?: string;
  textoCancelar?: string;
};

type ConfirmarFn = (opcoes?: ConfirmacaoOptions) => Promise<boolean>;

const ConfirmacaoContext = createContext<ConfirmarFn | null>(null);

export const useConfirmacao = (): ConfirmarFn => {
  const contexto = useContext(ConfirmacaoContext);
  if (!contexto) throw new Error('useConfirmacao deve ser usado dentro do ConfirmacaoProvider');
  return contexto;
};

export const ConfirmacaoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [aberto, setAberto] = useState(false);
  const [resolveFn, setResolveFn] = useState<(res: boolean) => void>(() => () => {});
  const [opcoes, setOpcoes] = useState<ConfirmacaoOptions>({});

  const confirmar: ConfirmarFn = (opts = {}) => {
    setOpcoes(opts);
    setAberto(true);
    return new Promise<boolean>((resolve) => {
      setResolveFn(() => resolve);
    });
  };

  const handleFechar = (res: boolean) => {
    setAberto(false);
    resolveFn(res);
  };

  return (
    <ConfirmacaoContext.Provider value={confirmar}>
      {children}
      <EasyModal open={aberto} onClose={() => handleFechar(false)} size='dialog'>
        <Box  sx={{height: '100%' }}>
          <DialogTitle>{opcoes.titulo || 'Confirmação'}</DialogTitle>
          <DialogContent>
            {opcoes.mensagem || 'Você tem certeza que deseja continuar?'}
          </DialogContent>
          <DialogActions sx={{bottom: 0}}>
            <Button onClick={() => handleFechar(false)} color="inherit">
              {opcoes.textoCancelar || 'Cancelar'}
            </Button>
            <Button onClick={() => handleFechar(true)} color="error">
              {opcoes.textoConfirmar || 'Confirmar'}
            </Button>
          </DialogActions>
        </Box>
      </EasyModal>
    </ConfirmacaoContext.Provider>
  );
};
